import React, { useState, useEffect } from 'react';
import axios from 'axios';

import {
  Container,
  Typography,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Snackbar,
  Alert,
  Stack,
} from '@mui/material';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

export default function ProductUnitHsnMapping() {
  const [products, setProducts] = useState([]);
  const [units, setUnits] = useState([]);
  
  const [hsns, setHsns] = useState([]);
  const [gstList, setGstList] = useState([]);

  const [mappings, setMappings] = useState([]);

  const [form, setForm] = useState({
  ProductName: '',
  UnitId: '',
  HSNCode: '',
  GstPercentageId: '',
  id: '',
});

  const [editing, setEditing] = useState(false);
  const [message, setMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

useEffect(() => {
  fetchProducts();
  fetchUnits();
  fetchHsns();
  fetchGst();        // ✅ add this
  fetchMappings();
}, []);

  const fetchProducts = async () => {
    try {
    const token = localStorage.getItem("token");

const res = await axios.get(`${BASE_URL}/Product/GetAllProducts`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
      
      alert(res.data.data)
      setProducts(res.data.data || []);
    } catch (err) {
      showMessage('Failed to fetch products', 'error');
    }
  };

  const fetchUnits = async () => {
    try {
      const token = localStorage.getItem("token");

const res = await axios.get(`${BASE_URL}/Unit/GetAllUnits`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
      setUnits(res.data.data || []);
    } catch (err) {
      showMessage('Failed to fetch units', 'error');
    }
  };

 const fetchHsns = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.get(
      `${BASE_URL}/HSNSac/GetAllHSNSacs`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setHsns(res.data.data || []);
  } catch (err) {
    showMessage("Failed to fetch HSN/SACs", "error");
  }
};

const fetchGst = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.get(
      `${BASE_URL}/GSTPercentage/GetAllGsts`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setGstList(res.data.data || []);
  } catch (err) {
    showMessage("Failed to fetch GST", "error");
  }
};

  const fetchMappings = async () => {
    try {
      const token = localStorage.getItem("token");

const res = await axios.get(`${BASE_URL}/ProductUnitHsnMapping/GetAllMappings`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
      setMappings(res.data.data || []);
    } catch (err) {
      showMessage('Failed to fetch mappings', 'error');
    }
  };

  const showMessage = (msg, severity = 'success') => {
    setMessage(msg);
    setAlertSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.ProductName || !form.UnitId || !form.HSNCode) {
  showMessage('Please select all dropdowns', 'warning');
  return;
}

    try {
      if (editing) {
        const token = localStorage.getItem("token");

const res = await axios.put(
  `${BASE_URL}/ProductUnitHsnMapping/UpdateMapping/${form.id}`,
  {
    ProductName: form.ProductName,
  UnitId: form.UnitId,
  HSNCode: form.HSNCode,
  GstPercentageId: form.GstPercentageId,
  gstNumber: localStorage.getItem("gstNumber"),
  },
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
        showMessage('Mapping updated successfully');
      } else {
        const token = localStorage.getItem("token");

const res = await axios.post(
  `${BASE_URL}/ProductUnitHsnMapping/AddMapping`,
  {
    ProductName: form.ProductName,
UnitId: form.UnitId,
HSNCode: form.HSNCode,
GstPercentageId: form.GstPercentageId,
gstNumber: localStorage.getItem("gstNumber"),
  },
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
        showMessage('Mapping added successfully');
      }

setForm({
  ProductName: '',
  UnitId: '',
  HSNCode: '',
  GstPercentageId: '',
  id: '',
});      
      setEditing(false);
      fetchMappings();
    } catch (err) {
      showMessage('Error saving mapping', 'error');
      console.error(err);
    }
  };

  const handleEdit = (mapping) => {
    setForm({
  ProductName: mapping.ProductName,
  UnitId: mapping.UnitId?._id || mapping.UnitId,
  HSNCode: mapping.HSNCode,
  GstPercentageId: mapping.GstPercentageId?._id || '',
  id: mapping.id,
});
    setEditing(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure to delete this mapping?')) return;
    try {
      const token = localStorage.getItem("token");

const res = await axios.delete(
  `${BASE_URL}/ProductUnitHsnMapping/DeleteMapping/${id}`,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
      showMessage('Mapping deleted successfully');
      fetchMappings();
    } catch (err) {
      showMessage('Failed to delete mapping', 'error');
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Product-Unit-HSN Mapping CRUD
      </Typography>

      <Paper sx={{ p: 3, mb: 4 }}>
        <form onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <FormControl fullWidth>
              <InputLabel id="product-label">Product</InputLabel>
              <Select
                labelId="product-label"
                id="ProductId"
               name="ProductName"
                value={form.ProductName}
              
                label="Product"
                onChange={handleChange}
                required
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {products.map((p) => (
                 <MenuItem key={p._id} value={p.ProductName}>
                  {p.ProductName}
                </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="unit-label">Unit</InputLabel>
              <Select
                labelId="unit-label"
                id="UnitId"
                name="UnitId"
                value={form.UnitId}
                label="Unit"
                onChange={handleChange}
                required
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {units.map((u) => (
                  <MenuItem key={u._id} value={u._id}>
                    {u.UnitName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="hsn-label">HSN/SAC</InputLabel>
              <Select
                labelId="hsn-label"
                id="HsnId"
                name="HSNCode"
                value={form.HSNCode}
                label="HSN/SAC"
                onChange={handleChange}
                required
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {hsns.map((h) => (
                  <MenuItem key={h._id} value={h.HSNCode}>
                    {h.HSNCode}
                </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
  <InputLabel id="gst-label">GST %</InputLabel>
  <Select
    labelId="gst-label"
    name="GstPercentageId"
    value={form.GstPercentageId}
    label="GST %"
    onChange={handleChange}
    required
  >
    <MenuItem value="">
      <em>None</em>
    </MenuItem>

    {gstList.map((g) => (
      <MenuItem key={g._id} value={g._id}>
        {g.PercentageValue} %
      </MenuItem>
    ))}
  </Select>
</FormControl>

            <Stack direction="row" spacing={2}>
              <Button type="submit" variant="contained" color="primary">
                {editing ? 'Update' : 'Add'} Mapping
              </Button>
              {editing && (
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setEditing(false);
                   setForm({
                    ProductName: '',
                    UnitId: '',
                    HSNCode: '',
                    GstPercentageId: '',
                    id: '',
                    });
                  }}
                >
                  Cancel
                </Button>
              )}
            </Stack>
          </Stack>
        </form>
      </Paper>

      <Typography variant="h5" gutterBottom>
        All Mappings
      </Typography>

      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Product Name</TableCell>
              <TableCell>Unit Name</TableCell>
              <TableCell>HSN/SAC Name</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mappings.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No mappings found.
                </TableCell>
              </TableRow>
            ) : (
              mappings.map((m) => (
                <TableRow key={m.id}>
                  <TableCell>{m.id}</TableCell>
                  <TableCell>{m.ProductName}</TableCell>
                  <TableCell>{m.UnitId?.UnitName}</TableCell>
                  <TableCell>{m.HSNCode}</TableCell>
                  <TableCell align="center">
                    <Button
                      variant="outlined"
                      size="small"
                      sx={{ mr: 1 }}
                      onClick={() => handleEdit(m)}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      color="error"
                      onClick={() => handleDelete(m.id)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Paper>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={alertSeverity}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {message}
        </Alert>
      </Snackbar>
    </Container>
  );
}
